import Rest from '@/services/Rest';

/**
 * @typedef {SellerRegisterService}
 */
export default class SellerRegisterService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/v2/adm/seller/register'
}
